export enum LoginEnum {
    LOGIN_WINDOW="LOGIN_WINDOW",
    CHANGE_PASSWORD="CHANGE_PASSWORD",
    SELECT_DATABASE="SELECT_DATABASE",
    CONNECTION_SUCESS="CONNECTION_SUCESS",
    CONNECTION_FAILED="CONNECTION_FAILED"
};